import React, { createContext, useContext, useState, ReactNode } from 'react'

interface SessionExpiredModalContextType {
    isSessionExpiredModalOpen: boolean
    setIsSessionExpiredModalOpen: (isOpen: boolean) => void
}

const SessionExpiredModalContext = createContext<SessionExpiredModalContextType | undefined>(undefined)

export const SessionExpiredModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isSessionExpiredModalOpen, setIsSessionExpiredModalOpen] = useState(false)

    return (
        <SessionExpiredModalContext.Provider value={{ isSessionExpiredModalOpen, setIsSessionExpiredModalOpen }}>
            {children}
        </SessionExpiredModalContext.Provider>
    )
}

export const useSessionExpiredModal = () => {
    const context = useContext(SessionExpiredModalContext)
    if (context === undefined) {
        throw new Error('useSessionExpiredModal must be used within a SessionExpiredModalProvider')
    }
    return context
}
